export const ROUTING_ACTION_TYPES = Object.freeze({
  EXCLUDE_ROUTING_GROUPS: 'EXCLUDE_ROUTING_GROUPS',
  ALLOWED_ROUTING_GROUPS: 'ALLOWED_ROUTING_GROUPS',
  //REORDER_ROUTING_GROUPS: 'REORDER_ROUTING_GROUPS',
  SKIP_ROUTING_GROUP: 'SKIP_ROUTING_GROUP',
  CHANGE_TIMEOUT: 'CHANGE_TIMEOUT',
  SET_PRIORITY: 'SET_PRIORITY'
});

export default ROUTING_ACTION_TYPES;
